import { databaseConfig } from '../../config/database';
import type { TerminalSetup } from '../../presentation/screens/login/terminalSetup';

const API = databaseConfig.mongodb.apiBaseUrl.replace(/\/$/, '');

export type PosInstallationRecord = {
  visibleId: string;
  deviceId: string;
  branchId: string;
  status: string;
};

export async function registerPosInstallation(
  token: string,
  payload: {
    deviceId: string;
    setup: TerminalSetup;
    runtime: 'web' | 'electron';
  },
): Promise<{ ok: true; data: PosInstallationRecord } | { ok: false; error: string }> {
  try {
    const res = await fetch(`${API}/api/kiosk/pos-installations/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        deviceId: payload.deviceId,
        branchId: payload.setup.branchId,
        storeName: payload.setup.storeName,
        branchName: payload.setup.branchName,
        branchAddress: payload.setup.branchAddress,
        receiptPrinterName: payload.setup.receiptPrinterName,
        barcodePrinterName: payload.setup.barcodePrinterName,
        receiptPaperSize: payload.setup.receiptPaperSize ?? '80mm',
        barcodeIncludeName: payload.setup.barcodeIncludeName !== false,
        barcodeIncludePrice: payload.setup.barcodeIncludePrice !== false,
        setupBy: payload.setup.setupBy,
        setupAt: payload.setup.setupAt,
        runtime: payload.runtime,
      }),
    });
    const json = (await res.json().catch(() => ({}))) as {
      data?: PosInstallationRecord;
      message?: string;
    };
    if (!res.ok || !json.data?.visibleId) {
      return {
        ok: false,
        error: json.message || `HTTP ${res.status}`,
      };
    }
    return { ok: true, data: json.data };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : String(err),
    };
  }
}

export async function clearPosInstallation(
  token: string,
  deviceId: string,
): Promise<boolean> {
  try {
    const res = await fetch(`${API}/api/kiosk/pos-installations/clear`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ deviceId }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
